import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { rutaInicio } from "../utils/rutaInicio";

/**
 * Protege rutas por autenticación y, opcionalmente, por perfil.
 * roles={['Administrador']} restringe la ruta solo a ese perfil.
 * requiere={(usuario) => bool} agrega una condición extra (ej. un flag individual
 * por usuario, no por perfil, como Usuarios.AccesoPagosExtra).
 */
export default function PrivateRoute({ children, roles, requiere }) {
  const { usuario } = useAuth();

  if (!usuario) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(usuario.perfil)) {
    return <Navigate to={rutaInicio(usuario)} replace />;
  }

  if (requiere && !requiere(usuario)) {
    return <Navigate to={rutaInicio(usuario)} replace />;
  }

  return children;
}
